enum ModelBaseNames {
  trees = 'trees',
  points = 'points',
}

export default ModelBaseNames;
